/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";

import { Row, Col, Form, Button, Table } from "react-bootstrap";

import DateEditor from "../../components/DateEditor";


export default function EditMilestonePane(props) {
  const [name, setName] = useState(props.modelMilestone.name);
  const [desc, setDesc] = useState(props.modelMilestone.desc);
  const [expr, setExpr] = useState(props.modelMilestone.expr);
  const [validated, setValidated] = useState(false); //???


  function onNameChanged(event) {
    event.preventDefault();

    setName(event.target.value);
  }

  function onDescChanged(event) {
    event.preventDefault();

    setDesc(event.target.value);
  }

  function onUpdateExpr(expr) {
    setExpr(expr);
  }


  function onSubmit(event) {
    event.preventDefault();

    let obj = {
      name,
      desc,

      expr: expr,
    };

    let action = {
      type: props.action, 
      milestone: { ...props.modelMilestone, ...obj }
    }

    props.onSubmit(action);
  }

  function onCancel(event) {
    event.preventDefault();

    props.onCancel();
  }

  

  return (
    <>
      <h2>Edit Item</h2>

      <Form noValidate validated={validated} onSubmit={onSubmit}>

        <Form.Group className="mb-3" controlId="desc">
          <Row>
          <Col xs={3}>
          <Form.Label >Name</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
          <Form.Control type="text" required value={name} onChange={onNameChanged} />
          </Col>
          </Row>
        </Form.Group>

        <Form.Group className="mb-3" controlId="desc">
          <Row>
          <Col xs={3}>
          <Form.Label >Description</Form.Label>
          </Col>
          <Col xs={5} sm={3}>
          <Form.Control type="text" required value={desc} onChange={onDescChanged} />
          </Col>
          </Row>
        </Form.Group>

        <Form.Group className="mb-3" controlId="bal">
          <Row>
          <Col xs={3}>
          <Form.Label>Start</Form.Label>
          </Col>
          <Col xs={9} sm={6}>
          <DateEditor simModel={props.simModel} expr={expr} onChange={onUpdateExpr} />
          </Col>
          </Row>
        </Form.Group>


          <Button variant="primary" type="submit" >Update</Button>
          <Button variant="secondary" type="button" onClick={onCancel}>Cancel</Button>

      </Form>

    </>
  );
}

